// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"188":"b78d9dfb","787":"76abfd3a"}[chunkId] + ".chunk.js";
};